// extracted by mini-css-extract-plugin
export default {"maincontainer":"EditResume_maincontainer__P6XXj"};